<div class="error">
  <svg-icon src="assets/svg/r2.svg"></svg-icon>
  <div class="text">
    <div class="heading">5xx error</div>
    <div class="sub">Sorry, I couldn't access the Death Star plans</div>
  </div>
</div>
